var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconThumbDown = function SvgIconThumbDown(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 20 20"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M2 9.5a1.5 1.5 0 1 0 3 0v-6a1.5 1.5 0 0 0-3 0zm4 .167v-5.43a2 2 0 0 1 1.106-1.79l.05-.025A4 4 0 0 1 8.943 2h5.416a2 2 0 0 1 1.962 1.608l1.2 6A2 2 0 0 1 15.56 12H12v4a2 2 0 0 1-2 2 1 1 0 0 1-1-1v-.667a4 4 0 0 0-.8-2.4l-1.4-1.866a4 4 0 0 1-.8-2.4"
  })));
};
export default SvgIconThumbDown;